import modal from '../patterns/modal.js';
import PL_utils from '../patterns/pl-utils.js';


const body = document.querySelector('body');
const isEDMode = window.location.href.indexOf('ed=1') > -1;
var instantiatedByEl = false;

// ModalHooks shared by modal exit and modal exit-alt
const modalHooks = {
  _hasScrolledToBottom: false,
  _addModalError: function (target) {},
  _removeModalError: function (target) {},
  beforeOpen: function (target) {
    PL_utils.addClass('modal-open', body);
  },
  afterOpen: function (target) {},
  onContinue: function (e, target) {
    exitModal.hideModal();
    exitModalAlt.hideModal();
  },
  onCancel: function () {
    return false;
  },
  beforeClose: function () {
    document.querySelectorAll('.modal').forEach((item) => {
      if (!item.getAttribute("hidden")) {
        item.setAttribute('hidden', "");
        item.setAttribute("aria-hidden", true);
      }
    });
    return false;
  },
  afterClose: function () {
    PL_utils.removeClass('modal-open', body);
    if (instantiatedByEl) {
      instantiatedByEl.focus();
      instantiatedByEl = false;
    }
  },
  setSize: function () {
    return false;
  },
  onScreenshot: function () {
    return false;
  },
  onInit: function (target) {}
};

const modalOpts = {
  enableBackdropClose: true
};

const appplyAccessibility = (ModalEle) => {
  var el_label = ModalEle.querySelector("[data-label]");
  if (el_label != null && !isEDMode) {
    ModalEle.setAttribute("aria-label", el_label.innerHTML);
    ModalEle.setAttribute("role", "dialog");
    ModalEle.setAttribute("aria-modal", "true");
    ModalEle.removeAttribute("hidden");
    ModalEle.removeAttribute("aria-hidden");
    ModalEle.setAttribute("tabIndex", "0");
  }
};

const applyDataDest = (modalEle,link) => {
  const goBackEle = modalEle.querySelector('.modal__cancel');
  const closeEle = modalEle.querySelector('.modal__close');

  if(goBackEle == null) {return;}
  if(closeEle == null) {return;}
  goBackEle.setAttribute("data-dest",link);
  closeEle.setAttribute("data-dest",link);
}

//MODAL EXIT
const exitModalEle = document.querySelector('.modal-exit');
const exitContinueBtn = exitModalEle.querySelector('.modal__continue');
const exitModal = modal.initModal(exitModalEle, modalHooks, modalOpts);
const exitModalTriggers = document.querySelectorAll('[data-external]');

//MODAL EXIT ALT
const exitModalEleAlt = document.querySelector('.modal-exit-alt');
const exitContinueBtnAlt = exitModalEleAlt.querySelector('.modal__continue');
const exitModalAlt = modal.initModal(exitModalEleAlt, modalHooks, modalOpts);
const exitModalTriggersAlt = document.querySelectorAll('[data-external-alt]');


export default () => {
  PL_utils.eleOnClick(function (e) {
    e.preventDefault();
    const link = e.currentTarget.getAttribute('href');
    exitContinueBtn.setAttribute('href', link);
    appplyAccessibility(exitModalEle);
    applyDataDest(exitModalEle,link);
    window.eventsManager.emit("showModal", {type: "external", params: link});
    exitModal.showModal();
    exitModalEle.focus();
    instantiatedByEl = (e.target);
  }, exitModalTriggers);


  PL_utils.eleOnClick(function (e) {
    e.preventDefault();
    const link = e.currentTarget.getAttribute('href');
    exitContinueBtnAlt.setAttribute('href', link);
    appplyAccessibility(exitModalEleAlt);
    applyDataDest(exitModalEleAlt,link);

    window.eventsManager.emit("showModal", {type: "external", params: link});
    exitModalAlt.showModal();
    exitModalEleAlt.focus();
  }, exitModalTriggersAlt);

  //screenshot
  if (isEDMode) {
    if (window.location.search.substring(1).split('&').indexOf('modal=external-1') > -1) {
      exitModal.showModal();
    }
    if (window.location.search.substring(1).split('&').indexOf('modal=external-2') > -1) {
      exitModalAlt.showModal();
    }
  }
}
